var map = {
	"./african-grey-parrot.png": "de24",
	"./alligator.png": "94f7",
	"./alpaca.png": "dbcf",
	"./anteater.png": "9e91",
	"./antelope.png": "0e17",
	"./ape.png": "890c",
	"./bat.png": "78fe",
	"./bee.png": "32e3",
	"./bowhead-whale.png": "5da7",
	"./buffalo.png": "56bc",
	"./butterfly.png": "b05d",
	"./camel.png": "9ab0",
	"./cat.png": "fc96",
	"./chicken.png": "737d",
	"./cow.png": "7e4c",
	"./crow.png": "9790",
	"./dinosaur.png": "e8f9",
	"./dog.png": "88ef",
	"./dove.png": "a41f",
	"./duck.png": "e6ae",
	"./elephant.png": "b706",
	"./falcon.png": "c39b",
	"./ferret.png": "33b9",
	"./frog.png": "5860",
	"./giraffe.png": "807b",
	"./guinea-pig.png": "bc1e",
	"./hedgehog.png": "e0bb",
	"./hippopotamus.png": "dfc6",
	"./horse.png": "f5fe",
	"./humpback-whale.png": "ff98",
	"./hyena.png": "300d",
	"./komodo-dragon.png": "7a0f",
	"./leopard.png": "a642",
	"./lion.png": "9b7c",
	"./lizard.png": "407f",
	"./moose.png": "e335",
	"./otter.png": "3082",
	"./owl.png": "9be1",
	"./panda.png": "798a",
	"./penguin.png": "2a29",
	"./pig.png": "2ff2",
	"./rabbit.png": "a49f",
	"./raccoon.png": "8868",
	"./rat.png": "d87a",
	"./rattlesnake.png": "9bb8",
	"./rhinoceros.png": "2f26",
	"./robin.png": "1c15",
	"./rooster.png": "abe0",
	"./scorpion.png": "24d3",
	"./shark.png": "e204",
	"./sheep.png": "555e",
	"./swan.png": "d26c",
	"./tiger.png": "5e66",
	"./turkey.png": "3e15",
	"./wolf.png": "7b24",
	"./yak.png": "f817",
	"./zebra.png": "1ca7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b3a9";